import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { GetUserSuccess } from '@library/store/user/user.action';
import { LoadLangs } from '@library/store/lang/lang.actions';
import * as supportedLangs from 'src/assets/supportedLangs';
import moment from 'moment-timezone';

@Injectable()
export class InitEffects {
  constructor(
        private readonly actions$: Actions,
  ) { }

  getUserSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetUserSuccess),
      map((action) => {
        const language: string = action.user.administrative.lang ? action.user.administrative.lang : 'en-US';
        moment.locale(language);
        const countryCode: string = language.substring(0, 2);

        const veluxLangs = supportedLangs.SupportedLanguage.veluxMulti[language]
                    || supportedLangs.BackupLanguage.veluxMulti[countryCode]
                    || supportedLangs.DefaultLanguage.multi;

        const singleLang = supportedLangs.SupportedLanguage.single[language]
                    || supportedLangs.BackupLanguage.single[countryCode]
                    || supportedLangs.DefaultLanguage.single;

        return new LoadLangs({
          aliases: [
            { name: 'common-settings', locale: singleLang },
            { name: 'common-app', locale: singleLang },
            { name: 'settings', locale: veluxLangs },
            { name: 'app', locale: veluxLangs },
            { name: 'kit', locale: veluxLangs },
            { name: 'extractcommon', locale: veluxLangs },
          ],
          locale: action.user.administrative.reg_locale,
        });
      }),
    ),
  );
}
